/**
 * Author: Andrey Morozov
 * Confidential. Proprietary and confidential. Unauthorized copying or distribution is prohibited.
 */

import en from "./en.json";
/**
 * The console's i18n catalogs. They are merged on top of the design-system's
 * base RU/EN catalogs by the I18nProvider, so every component — DS and
 * console-local — resolves keys against one locale.
 */
import ru from "./ru.json";

export const CONSOLE_MESSAGES = { ru, en } as const;
